import React from "react";
import { CheckoutItemsProps } from "../../../../store/modules/checkout/types";
import { ProductImage } from "../ProductImage";
import { ContainerImagem, Content, ProductRow } from "../styles";
import { ProductDetail } from "../ProductDetail";
import { ProductCardActions } from "../ProductCartActions";

interface IProductConferenre {
    product: CheckoutItemsProps;
}

export function ProductConferenre({ product }: IProductConferenre) {
    return (
        <ProductRow>
            <ContainerImagem>
                <ProductImage product={product} />
            </ContainerImagem>
            <Content>
                <ProductDetail.Root>
                    <ProductDetail.Title title={product.product.short_description || ""} />
                    <ProductDetail.Price price={product.total} product={product.product} quantity={Number(product.quantity)} />
                </ProductDetail.Root>

                <ProductCardActions.Root>
                    {/* Container dos botões de quantidade com o valor */}
                    <span>Quantidade:</span>
                    <ProductCardActions.value inputValue={product.quantity} un={product.product?.un} />
                </ProductCardActions.Root>
            </Content>
        </ProductRow>
    )
}